<div class="container-sm-fluid pt-3 px-sm-4">
    <dx-tabs
        keyExpr="id"
        [items]="tabs"
        [selectedItemKeys]="selectedTabKeys"
        [showNavButtons]="false"
        stylingMode="primary"
        iconPosition="start"
        (onItemClick)="onTabClick($event.itemData.id)"
    ></dx-tabs>
</div>

@if (selectedTabKeys[0] === 'damage') {
    <app-mb51-charts [reason]="MB51Reason.Damage"></app-mb51-charts>
} @else if (selectedTabKeys[0] === 'adjustments') {
    <app-mb51-charts [reason]="MB51Reason.Adjustment"></app-mb51-charts>
} @else if (selectedTabKeys[0] === 'damage-data') {
    <app-mb51-quantities [reason]="MB51Reason.Damage"></app-mb51-quantities>
} @else if (selectedTabKeys[0] === 'adjustments-data') {
    <app-mb51-quantities [reason]="MB51Reason.Adjustment"></app-mb51-quantities>
} @else if (selectedTabKeys[0] === 'all-data') {
    <app-mb51-data></app-mb51-data>
}
